import React from 'react'
const Delete = () => {
  return (
    <div className="text-gray text-xs text-center pt-40">此页面已被删除</div>
  )
}

export default Delete